export const baseEvent = {
  context: 'IMAGE_RECOGNITION',
} as const

export enum BaseEventTypes {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
}
